// Dev-only console helpers. In production these become no-ops, keeping bundles cleaner
// and avoiding any leaked debug noise in user browsers.
const isDev = process.env.NODE_ENV !== "production";

export const logError = isDev ? console.error.bind(console) : () => {};
export const logWarn = isDev ? console.warn.bind(console) : () => {};
